<template>
  <div class="page">
    <Header>
      <template #title>
        <span>リトル・ママオンラインフェスタ</span>
        抽選会プレゼント一覧
      </template>
    </Header>
    <div class="presents-wrapper">
      <div class="inner">
        <Heading>
          <template #heading>
            抽選会キーワード3つで当たる<br>
            豪華商品がこちら
          </template>
        </Heading>
        <div class="explanation">
          <h2 class="name">みんなに当たるプレゼント</h2>
        </div>
        <div class="presents">
          <Present
            v-for="(present, index) in presents1" :key="index"
            :present="present"
          />
        </div>
        <div class="explanation">
          <h2 class="name">関東を味わおう賞</h2>
          <p class="comment">関東以外の全国から参加しているママに当たる関東ご当地食材</p>
        </div>
        <div class="presents">
          <Present
            v-for="(present, index) in presents3" :key="index"
            :present="present"
          />
        </div>
        <div class="explanation">
          <h2 class="name">関東ママ特別賞</h2>
          <p class="comment">関東ママに当たる特別プレゼント</p>
        </div>
        <div class="presents">
          <Present
            v-for="(present, index) in presents2" :key="index"
            :present="present"
          />
        </div>
        <div class="explanation">
          <h2 class="name">アーカイブ賞</h2>
          <p class="comment">アーカイブ抽選会で当たるプレゼントです。</p>
        </div>
        <div class="presents">
          <Present
            v-for="(present, index) in presents4" :key="index"
            :present="present"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/202010kantou/Header.vue'
import Heading from '@/components/atoms/Heading.vue'
import Present from '@/components/molecules/Present.vue'
export default {
  name: 'present',
  components: {
    Header,
    Heading,
    Present
  },
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    isAuthed: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    presents1: [
      {
        thumbnail: '/img/present10kantou/robot.png',
        name: 'Eufy RoboVac 11S (ロボット掃除機) ',
        num: '1名/1日',
        day: '3日間',
        description: 'お部屋に合わせて様々な掃除モードを選択でき、掃除のタイミングも設定可能。一般的な電子レンジの動作時と同程度の静かさでの掃除を実現しました。約7.2cmの高さのEufy RoboVac 11Sは家具の下など手の届きにくい場所でもあなたの代わりに掃除します。超薄型でありながら、BoostIQテクノロジー搭載かつ最大1300Paの吸引力を繰り出すEufy RoboVac 11Sは、床やカーペットに付着したあらゆるゴミやホコリを吸引することができます。',
        company: 'アンカー・ジャパン株式会社',
        url: 'https://www.ankerjapan.com/item/T2108.html'
      },
      {
        thumbnail: '/img/present10kantou/nappunappu.png',
        name: 'ナップナップベビーキャリー メッシュドライ',
        num: '1名/1日',
        day: '3日間',
        description: '小柄なお母さんでもフィット感抜群！本体が軽くて使いやすいナップナップベビーキャリーメッシュドライ。お子さまの肌があたる部分には肌当りの優しい高機能生地を採用！誰でもおんぶが簡単にできるおんぶ補助ホルダーやおむつやお財布などを入れてお出掛けできる大容量ポケットなど先輩ママの声がふんだんに盛り込まれています。',
        company: '株式会社ナップナップ',
        url: 'https://www.napnap.co.jp/SHOP/007d.html'
      },
      {
        thumbnail: '/img/present10kantou/ibushigin.png',
        name: 'イブシギンのしぜんだしセット',
        num: '10名/1日',
        day: '3日間',
        description: '原料は、鹿児島県屋久島近海で捕れた飛魚と鹿児島県指宿製造鰹荒節、北海道道南産昆布で絶妙なバランスで配合した自然素材のみのお出汁。添加物や食塩など余計な原材料は使わない、赤ちゃんが食べても大丈夫なほどに細かくしようと試行錯誤を行いました。今では、離乳食から大人の食事、塩分の気になる方まで多くの方にご愛用頂いております。きめ細かい粉末になっているので、お鍋に直接入れてお出汁としても、調理に直接振りかけて味のアクセントとしてもご使用頂けます。',
        company: '株式会社オリッジ',
        url: 'https://124gin.com/'
      },
      {
        thumbnail: '/img/present10kantou/kaki.png',
        name: '富有（ふゆう）柿',
        num: '5名',
        day: '10/24',
        description: '福岡県は全国有数の甘柿産地です。９月から翌２月頃まで品種をリレーしながら長期にわたっていろいろな柿が楽しめるよう生産していますが、今回はその中でも最も生産量が多く、甘柿の代表品種「富有柿」を提供いたします。橙紅色でツヤのある外観と甘味があってしっとりとした食感をお楽しみ下さい。',
        company: 'ＪＡ全農ふくれん　かき部会',
        url: 'https://zennoh-fukuren.jp/consumer/fruit/kaki'
      },
      {
        thumbnail: '/img/present10kantou/lifeResearch.png',
        name: 'レイチェルワイン　ミネラルメイクアップ　トライアルセット「ブロッサム・オパール」',
        num: '8名',
        day: '10/22',
        description: '肌へのやさしさとパウダーなのにしっとりとした質感が特徴のミネラルファンデーションと自然なツヤ感を与えるフェースパウダー、クセになる肌触りの本格ブラシがセットになったトライアルセット。',
        company: '株式会社ウィンフィールド・ライフリサーチ',
        url: 'https://www.rachelwine.com/'
      },
      {
        thumbnail: '/img/present10kantou/nooks1.png',
        name: 'DoneybyDeer食器セット',
        num: '8名',
        day: '10/23',
        description: 'DonebyDeerはデンマークのベビーキッズブランドです。テーブルウエアシリーズは、手元のおぼつかない小さな子どもたちの食事をフォローするため、深さや厚み、太さなどに工夫を重ね、子どもの手に合うベストなサイズ感に仕上げています。ボウル・スプーン・スパウトカップのセットで離乳食に必要なアイテムが揃ったセットです。初めて使うその日から、快適で楽しいお食事タイムを約束するシリーズです。<br>※コンパートメントプレートを中心としたカップやカトラリーをこちらでセットいたします。画像はイメージです。',
        company: 'nooks(パシフィック洋行株式会社）',
        url: 'http://nooks.shop/pr_donebydeer/'
      },
      {
        thumbnail: '/img/present10kantou/tearai.png',
        name: '絵本『てあらいできるかな』（作・絵：きむらゆういち）',
        num: '3名',
        day: '10/24',
        description: '大人気のしかけ絵本シリーズ最新刊！ウイルス対策にも注目されている「てあらい」は、おでかけの後は勿論、どろんこあそびの後、ごはんの前…毎日の子育てシーンに欠かせません。みんなといっしょに、あらっていけば、さいごは、おててはぴっかぴか！小さいうちから身につけておきたい、てあらいがたのしくなる絵本です。<br><a href="https://www.kaiseisha.co.jp/books/9784031311502" target=”_blank”>https://www.kaiseisha.co.jp/books/9784031311502</a><br>【オリジナルてあらいポスター】がダウンロードできます。（本は10月22日発売です）<br>ご自由にダウンロードいただき、おうちなどでご活用ください！',
        company: '株式会社 偕成社',
        url: 'https://www.kaiseisha.co.jp/books/9784031311502'
      }
    ],
    presents2: [
      {
        thumbnail: '/img/present10kantou/nooks2.png',
        name: 'タイニートイギフトセット',
        num: '4名',
        day: '10/24',
        description: '赤ちゃんの発達段階に合わせたトイ3点がセットになったギフトボックス。2～4ヶ月の赤ちゃんに適したガラガラ、3～5ヶ月の赤ちゃんのための歯固め、4～6ヶ月の赤ちゃんが両手の指先で遊べるおもちゃがセットになっているから、何かと迷ってしまいがちな出産祝いにもぴったり。',
        company: 'nooks(パシフィック洋行株式会社）',
        url: 'http://nooks.shop/pr_donebydeer/'
      },
      {
        thumbnail: '/img/present10kantou/tublock.png',
        name: 'チューブロック スターターセット ダイナソーズ',
        num: '5名',
        day: '10/22',
        description: '低年齢（３歳以上）から始められるスターターセットです。10種類以上のモデルが作れます。パーツのサイズもM・Lサイズなので組み立てやすいセットです。',
        company: 'エデュテ株式会社',
        url: 'https://tublock.jp/'
      },
      {
        thumbnail: '/img/present10kantou/aqua.png',
        name: 'ママアクアシャボン ハンドクリーム薬用 フラワーアロマウォータ 19A 80g',
        num: '5名',
        day: '10/23',
        description: 'ママ アクア シャボン 薬用美白ハンドクリーム。フラワーアロマウォーターの香り。ジェル状クリームが、手指にしっかり浸透し、メラニンの生成を抑え、日焼けによるシミ・そばかすを防ぎます。',
        company: '株式会社ウエニ貿易',
        url: 'https://www.aquasavon.jp/'
      },
      {
        thumbnail: '/img/present10kantou/ebara.png',
        name: 'エバラ商品 10種詰め合わせセット',
        num: '3名/1日',
        day: '3日間',
        description: '※最終日（10/24）のみ４名当選<br>焼肉のたれでお馴染みの、エバラ食品から人気の商品10種を詰め合わせ。焼肉はもちろん、照り焼きや炒め物にも使える「黄金の味」、お子さまの生野菜嫌いの克服に活躍する「浅漬けの素」、鍋以外にもスープの味付けに便利な「プチッと鍋」、CMで話題の「なべしゃぶ」など、毎日の食卓を簡単に・おいしくサポートするセットです。',
        company: 'エバラ食品工業株式会社',
        url: 'https://www.ebarafoods.com/'
      }
    ],
    presents3: [
      {
        thumbnail: '/img/present10kantou/syumai.png',
        name: '【10月限定】黒シウマイまん＆かぼちゃまん12個入',
        num: '2名/1日',
        day: '3日間',
        description: '横浜といえばみんな大好き崎陽軒のシウマイ！ハロウィンにちなんで黒色に仮装した「黒シウマイまん」とかぼちゃあんと角切りのかぼちゃを包んだ、ほっくりとした食感とやさしい甘みが特長の「かぼちゃまん」のセット。一口サイズのハロウィンをお楽しみください！',
        company: '株式会社 崎陽軒',
        url: 'https://shopping.kiyoken.com/shop/'
      },
      {
        thumbnail: '/img/present10kantou/niku.png',
        name: 'とちぎ和牛 肩ロース すき焼き用 (400g)',
        num: '1名/1日',
        day: '3日間',
        description: '「とちぎ和牛」は栃木県の指定された生産者によって肥育された黒毛和牛であり、枝肉格付がA・Bの４等級以上に格付された枝肉だけに与えられる銘柄名です。牛が本来もっている力を最大限に引き出し、熟成された風味豊かな最上級の和牛「とちぎ和牛」をすき焼きでお楽しみください。今なら「JAタウンとちぎ新鮮倉庫」で農家応援キャンペーン実施中！お肉やお米を送料無料でご購入いただけます♪',
        company: 'JA全農とちぎ（JAタウンとちぎ新鮮倉庫）',
        url: 'https://www.ja-town.com/shop/c/c3101/'
      }
    ],
    presents4: [
      {
        thumbnail: '/img/present10kantou/hasbro.png',
        name: 'こむぎねんど プレイ・ドー おたのしみセット',
        num: '10名',
        day: 'アーカイブ',
        description: 'プレイ・ドーは60年以上の歴史を持つ安全で信頼できるこむぎねんどブランド。きほんの4色、ヌードルマニア、くるくるスイーツメーカーがたっぷり入ったプレイセットで、想像力豊かに色を混ぜたり組み合わせて、お気に入りのパスタやお菓子を作って遊ぼう！<br>・プレイ・ドー　ヌードルマニア　2,000円<br>・プレイ・ドー　くるくるスイーツメーカー　2,000円<br>・プレイ・ドー4色セット　600円',
        company: 'ハズブロジャパン合同会社',
        url: 'https://shop.hasbro.com/ja-jp'
      },
      {
        thumbnail: '/img/present10kantou/niku.png',
        name: 'とちぎ和牛 肩ロース すき焼き用 (400g)',
        num: '1名',
        day: 'アーカイブ',
        description: '「とちぎ和牛」は栃木県の指定された生産者によって肥育された黒毛和牛であり、枝肉格付がA・Bの４等級以上に格付された枝肉だけに与えられる銘柄名です。牛が本来もっている力を最大限に引き出し、熟成された風味豊かな最上級の和牛「とちぎ和牛」をすき焼きでお楽しみください。今なら「JAタウンとちぎ新鮮倉庫」で農家応援キャンペーン実施中！お肉やお米を送料無料でご購入いただけます♪',
        company: 'JA全農とちぎ（JAタウンとちぎ新鮮倉庫）',
        url: 'https://www.ja-town.com/shop/c/c3101/'
      }
    ]
  }),
  mounted () {
    document.title = '抽選会プレゼント一覧 - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0 100px
.presents-wrapper
  background-color: $lightpink
  padding: 25px 0
  .explanation
    margin: 30px 0
    .name
      font-size: 20px;
      margin-bottom: 10px;
      color: #EC83A4;
    .comment
      font-size: 15px
  .presents
    .present
      margin-top: 25px
</style>
